(ns dashboard.views.settings.profile
  (:require
   [reagent.core :as reagent]
   [clojure.string :refer [split lower-case]]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen ->json json->]]
   [dashboard.events.users :as users-events]
   [dashboard.components.inputs :refer [input]]
   [dashboard.components.button :refer [button]]
   [dashboard.components.select :refer [select multiselect user-select]]
   ["date-fns" :refer [formatISO formatDistance format setDay]]))

(def locales
  {:en {:id :en
        :name "English"}
   :ja {:id :ja
        :name "日本語"}})

(def language-details
  {:en {:id :en
        :name "English"}
   :ja {:id :ja
        :name "Japanese"}
   :zh-cht {:id :zh-cht
            :name "Traditional Chinese"}
   :zh-chs {:id :zh-chs
            :name "Simplified Chinese"}
   :kr {:id :kr
        :name "Korean"}
   :fr {:id :fr
        :name "French"}})

(defn content []
  (reagent/with-let [!state (reagent/atom (listen ::subs/userinfo))]
    (fn []
      [:div
       (if (not (some? (:auth0UserId (listen ::subs/userinfo))))
         [:div.py-8.flex.justify-center
          [button
           {:on-click #(re-frame/dispatch
                        [::users-events/create-userinfo
                         {:user {:auth0UserId (get (listen :auth0/user-data) "sub")
                                 :email (get (listen :auth0/user-data) "name")
                                 :organizationId (:id (listen ::subs/organization))
                                 :locale :en
                                 :roleId "admin"}}])}
           "Create Profile"]]

         [:div.divide-y.divide-gray-200
          [:div.py-6.px-4.sm:p-6.lg:pb-8
           [:div.flex.flex-col.lg:flex-row
            [:div.flex-grow.space-y-6
             [:div.grid.grid-cols-12.gap-4
              [:div.col-span-12.sm:col-span-8
               [input
                {:id "first-name"
                 :label "First name"
                 :default-value (:firstName @!state)
                 :auto-complete "given-name"
                 :name "first-name"
                 :type "text"
                 :on-change #(swap! !state assoc :firstName %)}]]
              [:div.col-span-12.sm:col-span-4
               [input
                {:id "first-name-jp"
                 :label "名"
                 :default-value (:firstNameJp @!state)
                 :auto-complete "given-name"
                 :name "first-name-jp"
                 :type "text"
                 :on-change #(swap! !state assoc :firstNameJp %)}]]
              [:div.col-span-12.sm:col-span-8
               [input
                {:id "last-name"
                 :label "Last Name"
                 :default-value (:lastName @!state)
                 :auto-complete "family-name"
                 :name "last-name"
                 :type "text"
                 :on-change #(swap! !state assoc :lastName %)}]]
              [:div.col-span-12.sm:col-span-4
               [input
                {:id "last-name-jp"
                 :label "姓"
                 :default-value (:lastNameJp @!state)
                 :auto-complete "family-name"
                 :name "last-name-jp"
                 :type "text"
                 :on-change #(swap! !state assoc :lastNameJp %)}]]
              [:div.col-span-12.sm:col-span-8
               [input
                {:id "title"
                 :label (tr :user/title)
                 :default-value (:titleId @!state)
                 :auto-complete "title"
                 :name "title"
                 :type "text"
                 :on-change #(swap! !state assoc :titleId %)}]]
              [:div.col-span-12.sm:col-span-4
               [select
                {:label (tr :user/locale)
                 :class "mt-0.5"
                 :selected (get locales (keyword (:locale @!state)))
                 :items-list (vals locales)
                 :on-change #(swap! !state assoc :locale (keyword %))}]]]]
            [:div.flex-grow.lg:mt-0.lg:ml-6.lg:flex-grow-0.lg:flex-shrink-0
             [:p.text-sm.font-medium.text-gray-700
              {:aria-hidden true}
              "Photo"]
             [:div.mt-1.lg:hidden
              [:div.flex.items-center]
              [:div.flex-shrink-0.inline-block.rounded-full.overflow-hidden.h-12.w-12
               {:aria-hidden true}
               [:img.rounded-full.h-full.w-full
                {:src (:profile_picture_url @!state)}]
               [:div.ml-5.rounded-md.shadow-sm
                [:div.group.relative.border.border-gray-300.rounded-md.py-2.px-3.flex.items-center.justify-center.hover:bg-gray-50.focus-within:ring-2.focus-within:ring-offset-2.focus-within:ring-primary-500
                 [:label.relative.text-sm.leading-4.font-medium.text-gray-700.pointer-events-none
                  {:for "mobile-user-photo"}
                  [:span (tr :action/change)]
                  [:span.sr-only "user photo"]
                  [:input#mobile-user-photo.absolute.inset-0.w-full.h-full.opacity-0.cursor-pointer.border-gray-300.rounded-md
                   {:type "file"
                    :name "user-photo"}]]]]]]
             [:div.hidden.relative.rounded-full.overflow-hidden.lg:block
              [:img.relative.rounded-full.w-40.h-40
               {:src (:profile_picture_url @!state)}]
              [:label.absolute.inset-0.w-full.h-full.flex.items-center.justify-center.text-sm.font-medium.focus-within:opacity-100
               {:class (if (some? (:profile_picture_url @!state))
                         "bg-black bg-opacity-75 opacity-0 hover:opacity-100 text-white"
                         "bg-gray-50 hover:bg-gray-200")
                :for "desktop-user-photo"}
               [:span
                (if (some? (:profile_picture_url @!state))
                  (tr :action/change)
                  (tr :action/add))]
               [:span.sr-only "user photo"]
               [:input#desktop-user-photo.absolute.inset-0.w-full.h-full.opacity-0.cursor-pointer.border-gray-300.rounded-md
                {:type "file"
                 :name "user-photo"}]]]]]

           [:div.grid.grid-cols-12.mt-4.gap-4
            [:div.col-span-12
             [multiselect
              {:label (tr :user/spokenLanguages)
               :selected (map #(get language-details (keyword %)) (:spokenLanguages @!state))
               :items-list (vals language-details)
               :on-change #(do
                             (if (some? ((:spokenLanguages @!state) %))
                               (swap! !state assoc :spokenLanguages (disj (:spokenLanguages @!state) (keyword %)))
                               (swap! !state assoc :spokenLanguages (conj (:spokenLanguages @!state) (keyword %)))))}]]]

           [:div.grid.grid-cols-12.mt-4.gap-4
            [:div.col-span-6
             [input
              {:id "email"
               :label (tr :user/email)
               :default-value (:email @!state)
               :name "email"
               :type "email"
               :disabled? true}]]
            [:div.col-span-6
             [input
              {:id "role"
               :label (tr :user/role)
               :default-value (:name (get (listen ::subs/roles-by-id) (:roleId @!state)))
               :name "role"
               :type "type"
               :disabled? true}]]]]

          [:div
           [:div.py-6.px-4.sm:px-6
            [:p.text-sm.text-gray-500.sm:col-span-6
             "This account was created "
             (when-let [created (js/Date. (:created (listen ::subs/userinfo)))]
               [:time
                {:date-time (formatISO created)}
                (formatDistance created (js/Date.) #js {:addSuffix true
                                                        :locale (listen ::subs/date-fns-locale)})])]]]

          [:div.divide-y.divide-gray-200
           [:div.py-4.px-4.flex.justify-end.sm:px-6
            [button
             {:type "submit"
              :on-click #(re-frame/dispatch [::users-events/update-user
                                             {:user @!state}])}
             (tr :action/save)]]]])])))
